import { types } from 'mobx-state-tree'

export const AccessCodeDetailResponse = types.model('AccessCodeDetailResponse').props({
  redirect_url: types.maybe(types.string),
})
